import Vue from 'vue'

export default {
  create(payload) {
    return Vue.http.post('tcpa', { tcpaData: payload })
  }
}
